interface GetPaymentMethodsLabelProps {
  paymentMethodsLength: number;
  isBankSlipOnlyByProductFlow?: boolean;
}

export const getPaymentMethodsLabel = ({
  isBankSlipOnlyByProductFlow = false,
  paymentMethodsLength,
}: GetPaymentMethodsLabelProps) => {
  if (isBankSlipOnlyByProductFlow) {
    return 'Preencha os dados para emissão do boleto:';
  }

  if (paymentMethodsLength > 1) {
    return 'Selecione o método de pagamento:';
  }

  return '';
};
